// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationSchemaApi,
  ICertificationSchemaApiRequest,
  ICertificationSchemaApiGetDropdownAttrs,
  ICertificationSchemaApiDropdownResponse,
} from 'interfaces/back-office/master/certification-schema/certification-schema-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class CertificationSchemaApi extends BaseApi<ICertificationSchemaApi> implements ICertificationSchemaApiRequest {
  readonly url = ApiConstant.MASTER_CERTIFICATION_SCHEMA_URL
  private certificationSchemaUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get CertificationSchema dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationSchemaApiGetDropdownAttrs} payload
   *
   * @return {Promise<ICertificationSchemaApiDropdownResponse>} Promise<ICertificationSchemaApiDropdownResponse>
   */
  async masterCertificationSchema_getCertificationSchemaDropdown(
    payload: ICertificationSchemaApiGetDropdownAttrs,
  ): Promise<ICertificationSchemaApiDropdownResponse> {
    try {
      const response = await this.POST(`${this.certificationSchemaUrl}/dropdown`, payload?.body ? payload.body : {}, {
        ...payload.requestConfig,
      })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
